import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { RdsNullParameter, rdsNullParameterLabels } from '../models/filter/null-filter.model';

@Pipe({
  name: 'rdsNullParameterLabel',
})
export class NullParameterLabelPipe implements PipeTransform {
  transform(parameter: RdsNullParameter | undefined | null): string {
    if (!parameter) {
      return '';
    }
    return rdsNullParameterLabels[parameter];
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [NullParameterLabelPipe],
  declarations: [NullParameterLabelPipe],
})
export class RdsNullParameterLabelPipeModule {}
